'use client';

import React, { useContext } from 'react';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import { productContext } from '../products/productContext';
import {
  productSelectedOptionClassName,
  productContentComputeClassName,
  productListClassName,
  productItemClassName
} from './Styles';
import Compute from './Compute';
import Storage from './Storage';
import Networking from './Networking';
import DataSyncPricing from './DataSyncPricing';

export default function Pricing() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  const { selectedWorkload, setSelectedWorkload } = useContext(productContext);

  return (
    <div className={productContentComputeClassName}>
      <hr className="border-gray-200 m-0 w-full" />
      <div className={productListClassName}>
        <div className={productItemClassName}>
          <span
            className={`px-s ${selectedWorkload === 'Compute' ? productSelectedOptionClassName : ''}`}
            onClick={() => setSelectedWorkload('Compute')}>
            {t('public.site.pricing.workload.compute', {})}
          </span>
          <span
            className={`px-s ${selectedWorkload === 'Storage' ? productSelectedOptionClassName : ''}`}
            onClick={() => setSelectedWorkload('Storage')}>
            {t('public.site.pricing.workload.storage', {})}
          </span>
          <span
            className={`px-s ${selectedWorkload === 'Networking' ? productSelectedOptionClassName : ''}`}
            onClick={() => setSelectedWorkload('Networking')}>
            {t('public.site.pricing.workload.networking', {})}
          </span>
          <span
            className={`px-s ${selectedWorkload === 'DataSync' ? productSelectedOptionClassName : ''}`}
            onClick={() => setSelectedWorkload('DataSync')}>
            {t('public.site.pricing.workload.datasync', {})}
          </span>
        </div>
      </div>
      {selectedWorkload === 'Compute' && <Compute />}
      {selectedWorkload === 'Storage' && <Storage />}
      {selectedWorkload === 'Networking' && <Networking />}
      {selectedWorkload === 'DataSync' && <DataSyncPricing />}
    </div>
  );
}
